<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <div v-if="Loading==true">
            <div class="d-flex justify-content-center">
              <h1>Daftar</h1>
            </div>
            <br />
            <div class="d-flex justify-content-center">
              <PulseLoader float />
            </div>
          </div>
          <div v-else>
            <b-card no-body class="mx-4">
              <b-card-body class="p-4">
                <b-form>
                  <h1>Daftar</h1>
                  <p class="text-muted">Daftar sebagai pemohon baru</p>
                  <span>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Nama Seperti Dalam Kad Pengenalan"
                        autocomplete="first-name"
                        v-model="firstname"
                        @keyup="replaceInvertedComma()"
                        @change="replaceInvertedComma()"
                      />
                    </b-input-group>
                    <span
                      class="error"
                      v-show="firstname && !replaceInvertedComma()"
                    >
                      <span style="color:red;">Nama tidak boleh mengandungi digit</span>
                      <hr />
                    </span>
                    <span
                      class="error"
                      v-show="firstname && identityNo && IsPasswordEqual(firstname, identityNo)"
                    >
                      <span style="color:red;">No. Kad Pengenalan dikesan sebagai nama</span>
                      <hr />
                    </span>
                  </span>
                  <span>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-credit-card"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        class="form-control"
                        placeholder="No. Kad Pengenalan Baru"
                        autocomplete="icno"
                        maxlength="12"
                        min="12"
                        v-model="identityNo"
                      />
                    </b-input-group>
                    <span class="error" v-show="identityNo && (!IsIdentityValid(identityNo) || 12!=identityNo.length)">
                      <span style="color:red;">No. Kad Pengenalan tidak sah</span>
                      <hr />
                    </span>
                  </span>
                  <span>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>@</b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="email"
                        class="form-control"
                        placeholder="Alamat E-mel"
                        autocomplete="email"
                        v-model="email"
                      />
                    </b-input-group>
                    <span class="error" v-show="email && !IsEmailValid(email)">
                      <span style="color:red;">Alamat emel tidak sah.</span>
                      <hr />
                    </span>
                  </span>
                  <span>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>@</b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="email"
                        class="form-control"
                        placeholder="Sahkan Alamat E-mel"
                        autocomplete="email"
                        v-model="confirmEmail"
                      />
                    </b-input-group>
                    <span class="error" v-show="confirmEmail && !IsEmailValid(confirmEmail)">
                      <span style="color:red;">Alamat emel tidak sah.</span>
                      <hr />
                    </span>
                    <span
                      class="error"
                      v-show="email && confirmEmail && !IsPasswordEqual(email, confirmEmail)"
                    >
                      <span style="color:red;">Emel tidak sepadan.</span>
                      <hr />
                    </span>
                  </span>
                  <span>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-phone"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        class="form-control"
                        placeholder="No. Telefon Bimbit"
                        v-model="cellPhoneNo"
                      />
                    </b-input-group>
                  </span>
                  <p class="text-muted">Kata laluan</p>
                  <span>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        class="form-control"
                        placeholder="Kata Laluan"
                        v-model="password"
                      />
                    </b-input-group>
                    <b-alert show v-if="password && !IsPasswordValid(password)" variant="danger">
                      Kata laluan perlu mengandungi sekurang-kurangnya
                      <br />• 8 hingga 20 aksara,
                      <br />• Satu huruf besar,
                      <br />• Satu huruf kecil, dan
                      <br />• Satu digit
                    </b-alert>
                  </span>
                  <span>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        class="form-control"
                        placeholder="Sahkan Kata Laluan"
                        v-model="confirmPassword"
                      />
                    </b-input-group>
                    <span
                      class="error"
                      v-show="password && confirmPassword && !IsPasswordEqual(password, confirmPassword)"
                    >
                      <span style="color:red;">Kata laluan tidak sepadan.</span>
                      <hr />
                    </span>
                  </span>
                  <b-button
                    :disabled="!FormCompleted"
                    variant="success"
                    block
                    v-on:click="Register"
                  >Daftar akaun</b-button>
                  <b-button
                    variant="primary"
                    block
                    v-on:click="Register"
                    :href="publicPath + '#/Login'"
                  >Kembali ke Login</b-button>
                </b-form>

                <div v-if="this.Error==true">
                  <hr />
                  <b-alert show variant="danger">{{this.Message}}</b-alert>
                </div>
              </b-card-body>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Vue from "vue";
import moment from "moment";
Vue.use(require("vue-moment"));

export default {
  name: "SignUp",
  components: {
    PulseLoader,
    moment,
  },
  data: function() {
    return {
      publicPath: process.env.BASE_URL,

      identityNo: "",
      password: "",
      confirmPassword: "",
      email: "",
      confirmEmail: "",
      firstname: "",
      cellPhoneNo: "",

      Loading: false,
      Error: false,
      Message: ""
    };
  },
  methods: {
    Register() {
      this.Error = false;
      this.Loading = true;

      const formData = new FormData();

      if (
        this.identityNo === "" ||
        this.identityNo.length < 12 ||
        this.password === "" ||
        this.email === "" ||
        this.firstname === ""
      ) {
        this.Loading = false;
        this.Error = true;
        this.Message = "Sila lengkapkan borang pendaftaran.";
      } else {
        formData.append("identityNo", this.identityNo);
        formData.append("password", this.password);
        formData.append("email", this.email);
        formData.append("firstname", this.firstname);

        this.$API
          .post(this.$Register, formData, { withCredentials: true })
          .then(response => {
            this.info = response.data;

            if (response.status == 202) {
              this.$dialog.alert(
                "Anda telah berjaya mendaftar. Sila buat pengesahan email terlebih dahulu. Jika anda tidak menerima e-mel pengesahan dalam tempoh 1 jam dari masa pendaftaran, sila emel ke pasukan teknikal BPP ke ictbpp@mara.gov.my"
              );
              // update cell phone number
              this.updateCellPhoneNumber();
              this.$router.push("/VerificationCode");
            } else if (response.status == 200) {
              this.Loading = false;
              this.Error = true;
              this.Message =
                "Pendaftaran tidak berjaya, sila cuba sekali lagi. " +
                this.info.detail;
            } else if (response.status == 500) {
              this.Loading = false;
              this.Error = true;
              this.Message =
                "Pendaftaran tidak berjaya, sila cuba sekali lagi. " +
                this.info.detail;
            } else {
              this.Loading = false;
              this.Error = true;
              this.Message = response.detail;
            }
          })
          .catch(error => {
            console.log(error);
            this.Loading = false;
            this.Error = true;
            this.Message =
              "Pendaftaran tidak berjaya. " + error.response.data.detail;
            this.$dialog.alert(this.Message);
          });
      }
    },
    replaceInvertedComma() {
      let fN = 'replaceInvertedComma: ';
      this.firstname = this.firstname.replace("`","'");
      const isNumber = /\d/.test(this.firstname);
      if (true == isNumber) {
        return false;
      } else {
        return true;
      }
    },
    updateCellPhoneNumber() {
      const formData = new FormData();
      formData.append("IdentityNo", this.identityNo);
      formData.append("CellPhoneNo", this.cellPhoneNo);
      return this.$API
        .post(this.$RegisterCellPhoneNumber, formData, { withCredentials: true, })
        .then((response) => {
          if (response.status == 200) {
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(item);
          console.log(error);
        });
    },
  },
  computed: {
    FormCompleted: {
      get: function() {
        if (
          !this.firstname ||
          !this.IsEmailValid(this.email) ||
          !this.IsIdentityValid(this.identityNo) ||
          !this.IsPasswordValid(this.password) ||
          !this.IsPasswordEqual(this.password, this.confirmPassword)
        )
          return false;
        else return true;
      },
    },
  },
};
</script>
